import React, { useEffect, useState } from "react";
import {
  makeStyles,
  Typography,
  DialogContent,
  Dialog,
  DialogTitle,
  Icon,
  Button,
  Link,
} from "@material-ui/core";
import { useHistory } from "react-router";
import { get } from "lodash";
import { getConf } from "@configuratorware/configurator-frontendgui/App/configuration.js";
import { t } from "@configuratorware/configurator-frontendgui/Framework/i18n";
import Progress from "@configuratorware/configurator-frontendgui/App/Shared/Components/Progress/Progress";
import CustomDialog from "@configuratorware/configurator-frontendgui/Shared/Components/CustomDialog";
import { Order } from "../../Types/Types";

export const useStyles = makeStyles(
  (theme) => ({
    dialogContent: {},
    dialogCloseButton: {
      position: "absolute",
      top: theme.spacing(2),
      right: theme.spacing(3),
      cursor: "pointer",
    },
    dialogPaper: {
      borderTop: `${theme.spacing(1)}px solid ${theme.palette.primary.main}`,
      width: "100%",
    },
    dialogTitle: {
      position: "relative",
    },
    listDialog: {
      maxWidth: 560,
      margin: "auto",
    },
    itemContainer: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      minHeight: 60,
    },
    imgContainer: {
      display: "flex",
      alignItems: "center",
    },
    link: {
      cursor: "pointer",
    },
    itemImage: {
      maxWidth: 100,
      maxHeight: 75,
      margin: "0px 10px 10px 0px",
    },
  }),
  { name: "OrderList" }
);

export interface BasketListProps {
  show: boolean;
  onClose: () => void;
  loadOrders: () => void;
  loadCode: (code) => void;
  orders: Order[];
  setConfigurationFromList: (flag) => void;
}

const OrderList = (props: BasketListProps) => {
  const classes = useStyles();
  const { show, onClose, orders, loadCode, setConfigurationFromList } = props;
  const history = useHistory();
  const [showLoader, setShowLoader] = useState(false);
  const resourcePath = get(getConf().network, "resourcesURL", "");

  useEffect(() => {
    show && props.loadOrders();
  }, [show]);

  return (
    <Dialog
      open={show}
      className={classes.listDialog}
      classes={{
        paper: classes.dialogPaper,
      }}
      onClose={onClose}
    >
      <DialogTitle className={classes.dialogTitle} disableTypography>
        <Typography variant="h6">{t("orderList.title")}</Typography>

        <Icon className={classes.dialogCloseButton} onClick={onClose}>
          close
        </Icon>
        <Typography>
        </Typography>
      </DialogTitle>
      <DialogContent className={classes.dialogContent}>
        <Progress loading={showLoader} />
        {orders.map((order) => (
          <div className={classes.itemContainer}>
            <div className={classes.imgContainer}>
              <img
                className={classes.itemImage}
                src={resourcePath + order.thumbnail}
                alt=""
              />
              <Typography variant="body2">{order.name}</Typography>
            </div>
            <Typography
              className={classes.link}
              onClick={async () => {
                setShowLoader(true);
                setConfigurationFromList(true);
                await loadCode(order.code);
                setShowLoader(false);
                history.push("/code:" + order.code);
                onClose();
                setConfigurationFromList(false);
              }}
            >
              {t("orderList.reorder")}
            </Typography>
          </div>
        ))}
      </DialogContent>
    </Dialog>
  );
};

export default OrderList;
